import {SuccessSVG, SuccessStatusSVG} from "assets";
import React from "react";
import {ColumnsEdit} from "types/models/column-table-edit";
import "./Prepay.scss";
import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
import {formatToCurrencyType} from "helper/common";
import TTTTTypeColumn from "components/common/ColumnColors/KCBTypeColumn/TTTTTypeColumn";
const {INPUT, SELECT, DATE, CURRENCY} = FIELD_TYPE;

const inputField: DataFormField[] = [
  {
    type: CURRENCY,
    name: "tongTienNguoiBenhTamUng",
    label: "Tổng tiền tạm ứng",
    placeholder: "-",
    css: {sm: 24, md: 6, lg: 6},
    disable: true,
    labelCol: { xs: 10, md: 10, lg: 10, xl: 8 },
    wrapperCol: { xs: 14, md: 14, lg: 14, xl: 16 },
  },
  // {
  //   type: SELECT,
  //   name: "idHinhThucThanhToan",
  //   label: "Hình thức TT",
  //   placeholder: "-",
  //   css: {sm: 24, md: 6, lg: 6},
  //   options: [
  //     {value: 0, label: "Tiền mặt"},
  //     {value: 1, label: "Chuyển khoản"},
  //     {value: 2, label: "Quẹt thẻ"},
  //   ],
  //   rules: [
  //     {
  //       required: true,
  //       message: "Bạn phải nhập trường bắt buộc",
  //     },
  //   ],
  // },

  // {
  //   type: CURRENCY,
  //   name: "soTienGiaoDich",
  //   label: "Số tiền",
  //   placeholder: "-",
  //   css: {sm: 24, md: 6, lg: 6},
  //   rules: [
  //     {
  //       required: true,
  //       message: "Bạn phải nhập trường bắt buộc",
  //     },
  //   ],
  // },
  // {
  //   type: INPUT,
  //   name: "maGiaoDich",
  //   label: "Mã giao dịch",
  //   placeholder: "-",
  //   css: {sm: 24, md: 6, lg: 6},
  // },
];

const columnsPrepay: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: "6%",
    align: "center",
  },
  {
    title: "Số phiếu",
    dataIndex: "soPhieu",
    key: "soPhieu",
    // editable: true,
    // width: '13%',
    align: "center",
  },
  {
    title: "Lý do tạm ứng",
    dataIndex: "reason",
    key: "reason",
    // editable: true,
    // width: '13%'
  },
  {
    title: "Người lập",
    dataIndex: "nguoiDeNghi",
    key: "nguoiDeNghi",
    // editable: true,
    // width: '13%'
  },
  {
    title: "Khoa NB",
    dataIndex: "khoaNB",
    key: "khoaNB",
    // editable: true,
    // width: '13%'
    // render: khoaNB => {
    //   if (khoaNB == 0)
    //     return (
    //       <div className="status-pay">
    //         <div>Khu khám thường</div>
    //       </div>
    //     );
    //   if (khoaNB == 1)
    //     return (
    //       <div className="status-pay">
    //         <div>Khu VIP</div>
    //       </div>
    //     );
    //   if (khoaNB == 2)
    //     return (
    //       <div className="status-pay">
    //         <div>Khoa khám bệnh</div>
    //       </div>
    //     );
    //   if (khoaNB == 3)
    //     return (
    //       <div className="status-pay">
    //         <div>Khoa mắt tổng hợp</div>
    //       </div>
    //     );
    //   if (khoaNB == 4)
    //     return (
    //       <div className="status-pay">
    //         <div>Khoa cận lâm sàng</div>
    //       </div>
    //     );
    // },
  },
  // {
  //   title: "Ngày để nghị",
  //   dataIndex: "ngayDeNghi",
  //   key: "ngayDeNghi",
  //   // editable: true,
  //   // width: '13%',
  //   align: "right",
  // },
  {
    title: "Ngày duyệt",
    dataIndex: "ngayDuyet",
    key: "ngayDuyet",
    // editable: true,
    // width: '13%',
    align: "center",
  },
  {
    title: "Số tiền",
    dataIndex: "soTien",
    key: "soTien",
    // editable: true,
    // width: '13%',
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Hình thức TT",
    dataIndex: "hinhThucTT",
    key: "hinhThucTT",
    // editable: true,
    // width: '13%',
    align: "left",
    render: hinhThucTT => {
      if (hinhThucTT == 0)
        return (
          <div className="status-pay">
            <div>Tiền mặt</div>
          </div>
        );
      if (hinhThucTT == 1)
        return (
          <div className="status-pay">
            <div>Chuyển khoản</div>
          </div>
        );
      if (hinhThucTT == 2)
        return (
          <div className="status-pay">
            <div>Quẹt thẻ</div>
          </div>
        );
      // if (hinhThucTT == 3)
      //   return (
      //     <div className="status-pay">
      //       <div>Momo</div>
      //     </div>
      //   );
    },
  },
  {
    title: "Trạng thái",
    dataIndex: "status",
    key: "status",
    // width: '13%',
    align: "left",
    render: text => {
      let textTT;
      if (text == 0 || text) {
        textTT = "Đã duyệt";
      } 
      return <TTTTTypeColumn label={textTT}></TTTTTypeColumn>;
    },
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    // editable: true,
    // width: '13%',
    align: "center",
  },
];

export {columnsPrepay, inputField};
